import React from "react";
import { KIT_ROWS, KIT_INCLUDES } from "../../data/content";
import { CheckIcon, XIcon } from "lucide-react";
export function KitComparison() {
  return <section className="bg-black py-16 px-4" data-id="element-151" data-mp="2snv0ea3o68xs">
      <div className="max-w-5xl mx-auto" data-id="element-152" data-mp="37fdlunfasvoj">
        <h2 className="font-display text-3xl sm:text-4xl text-white text-center uppercase mb-2" data-id="element-153" data-mp="37g6md6nnyoy8">
          🕊️ ¿Qué agrega el Kit Escalamiento y Marca Personal?
        </h2>
        <p className="text-center text-neutral-500 text-sm mb-8 md:hidden" data-id="element-154" data-mp="3geioo5xw7b6i">← Deslizá para ver la tabla completa →</p>

        <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-neutral-800" data-id="element-155" data-mp="3bfxizqzvfzao">
          <table className="w-full min-w-[640px] text-sm" data-id="element-156" data-mp="3qd7uh0cil56e">
            <thead data-id="element-157" data-mp="3le3nmgd2bjj8">
              <tr className="bg-neutral-950 text-left" data-id="element-158" data-mp="3lfohs4vgt0gk">
                <th className="p-4 font-condensed text-lg text-white tracking-wide" data-id="element-159" data-mp="1vzp36892uitj">Situación en tu negocio</th>
                <th className="p-4 font-condensed text-lg text-neutral-400 tracking-wide" data-id="element-160" data-mp="1r0vmy82eodpo">❌ Sin Kit PRO</th>
                <th className="p-4 font-condensed text-lg text-[#e10600] tracking-wide" data-id="element-161" data-mp="1ern7cr6dc59k">✅ Con Kit PRO</th>
              </tr>
            </thead>
            <tbody data-id="element-162" data-mp="1isyqcduqls8s">
              {KIT_ROWS.map((r, i) => <tr key={i} className={i % 2 ? "bg-black" : "bg-neutral-950/50"} data-id="element-163" data-mp="1ns1w60ijk2ht" data-mpi={i}>
                  <td className="p-4 text-neutral-300 align-top" data-id="element-164" data-mp="1sii9zlq9xq4p">{r.situation}</td>
                  <td className="p-4 text-neutral-500 align-top" data-id="element-165" data-mp="1sklbp30sh7p9">
                    <span className="flex items-start gap-2" data-id="element-166" data-mp="1xgtj1u8qvwlv">
                      <XIcon className="w-4 h-4 text-neutral-600 mt-0.5 flex-shrink-0" data-id="element-167" data-mp="22gfxu8481kws" />
                      {r.without}
                    </span>
                  </td>
                  <td className="p-4 text-white align-top" data-id="element-168" data-mp="26g6yd3jjvfei">
                    <span className="flex items-start gap-2" data-id="element-169" data-mp="2bg300w4ryuqw">
                      <CheckIcon className="w-4 h-4 text-[#e10600] mt-0.5 flex-shrink-0" data-id="element-170" data-mp="c4iecmygomn9" />
                      {r.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-12 bg-neutral-950 border border-neutral-800 rounded-2xl p-6 sm:p-8" data-id="element-171" data-mp="1kf24ezzr4ctx">
          <h3 className="font-condensed text-2xl text-[#e10600] tracking-wide mb-6 text-center" data-id="element-172" data-mp="1fghcdnunkzgk">
            ✅ El Kit Maestro PRO incluye:
          </h3>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-173" data-mp="1ofuflys6orsu">
            {KIT_INCLUDES.map(k => <li key={k.title} className="flex items-start gap-3" data-id="element-174" data-mp="1ohyrb2wbqv3o">
                <CheckIcon className="w-5 h-5 text-[#e10600] mt-1 flex-shrink-0" data-id="element-175" data-mp="23btrzlmbte3s" />
                <div data-id="element-176" data-mp="1ycz1dxi4al94">
                  <span className="text-white font-semibold" data-id="element-177" data-mp="1ydiixd3uv7mm">{k.title}</span>
                  <span className="text-neutral-400" data-id="element-178" data-mp="2c4dk03844kfn"> — {k.desc}</span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}